<template>
    <div>
        <CommonPopupFrame :changeHeight="'auto'" :changeBottom="0" :isOpen="isOpenCalendar" :closeCompleteAction="closeCalendar">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="margin-top: 16px; padding: 0 18px; padding-bottom: 10px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f5f5f5">
                <div @click="closeCalendar">
                    <img style="width: 40px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                </div>
                <div style="font-weight: 700">일정 설정</div>
                <div @click="closeCalendar" style="display: flex; align-items: center; gap: 6px;">
                    <div style="font-weight: 700; color: var(--color-main);">설정</div>
                </div>
            </div>
            <div @touchmove.stop="() => { }" style="background-color: #f5f5f5; flex: 1;">
                <div v-if="!isJoin" :style="{ width: '211px' }" style="position: relative; border-radius: 10px; margin: 0 auto; background-color: #d9d9d9; display: flex; padding: 8px 0; margin-top: 20px; margin-bottom: 20px;">
                    <div :style="{ left: viewOption === VIEW_OPTION.ONCE ? '2px' : '104px' }" style="transition: left 0.4s; width: 105px; height: 26px; background-color: #fff; position: absolute; top: 2px; border-radius: 8px"></div>
                    <div :style="{ color: viewOption === VIEW_OPTION.ONCE ? '' : '#808080' }" @click="setViewOption(VIEW_OPTION.ONCE)" style="font-size: 14px; font-weight: 500; position: relative; z-index: 10; flex: 1; text-align: center">한 번만</div>
                    <div :style="{ color: viewOption === VIEW_OPTION.EVERY_WEEK ? '' : '#808080' }" @click="setViewOption(VIEW_OPTION.EVERY_WEEK)" style="font-size: 14px; font-weight: 500; position: relative; z-index: 10; flex: 1; text-align: center">매주</div>
                </div>
                <div style="height: 30px;"></div>
                <div style="position: relative; width: 100%; height: 430px;">
                    <div :style="{ transform: viewOption === VIEW_OPTION.ONCE ? 'translateX(0)' : 'translateX(-100%)' }" style="position: absolute; padding-bottom: 40px; width: 100%; transition: all 0.4s;">
                        <ScheduleSettingCalendar :detect-select-date="detectSelectDate" :init-date="join_date"></ScheduleSettingCalendar>
                    </div>
                    <div :style="{ transform: viewOption === VIEW_OPTION.EVERY_WEEK ? 'translateX(0)' : 'translateX(100%)' }" style="position: absolute; width: 100%; transition: all 0.4s;">
                        <div style="padding: 12px 20px; font-weight: 500; border-top-left-radius: 12px; border-top-right-radius: 12px; background-color: #fff; width: calc(100% - 40px); margin: 0 auto; margin-bottom: 8px;">
                            <div style="font-size: 14px;">요일 선택</div>
                        </div>
                        <div style="font-weight: 500; background-color: #fff; width: calc(100% - 40px); margin: 0 auto; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
                            <div @click=setRepeatDay(each) v-for="each, i in dayOfWeeks" :key="i" style="display: flex; gap: 6px; align-items: center;">
                                <div style="padding: 12px 30px; padding-right: 0; border-bottom: 1px solid #f5f5f5;">{{ each }}</div>
                                <img v-if="Array.isArray(repeatDay) ? repeatDay.includes(each) : repeatDay === each" style="width: 12px;" :src="require('@/assets/img/check_day.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
    import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
    import ScheduleSettingCalendar from '@/components/common/ScheduleSettingCalendar'

    const VIEW_OPTION = {
        ONCE: '한 번만',
        EVERY_WEEK: '매주'
    }

    export default {
        name: 'ScheduleSettings',
        components: { CommonPopupFrame, ScheduleSettingCalendar },
        props: {
            isOpenCalendar: {
                type: Boolean,
                default: false,
            },
            closeCalendar: {
                type: Function,
                default: () => { }
            },
            detectSelectDate: {
                type: Function,
                default: () => { }
            },
            resetJoinDate: {
                type: Function,
                default: () => { }
            },
            setRepeatDay: {
                type: Function,
                default: () => { }
            },
            resetRepeatDay: {
                type: Function,
                default: () => { }
            },
            repeatDay: {
                type: [String, Array],
                default: ''
            },
            isRepeat: {
                type: Boolean,
                default: false
            },
            isModify: {
                type: Boolean,
                default: false
            },
            joinDate: {
                type: String,
                default: ''
            },
            isJoin: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                VIEW_OPTION: VIEW_OPTION,
                viewOption: VIEW_OPTION.ONCE,
                join_date: '',
                dayOfWeeks: ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일']
            }
        },
        methods: {
            setViewOption(type) {
                if (this.isModify) {
                    return
                }
                this.viewOption = type;
                if (this.viewOption === VIEW_OPTION.EVERY_WEEK) {
                    this.resetJoinDate()
                } else {
                    this.resetRepeatDay()
                }
            }
        },
        watch : {
            isRepeat(){
                if (this.isRepeat) {
                    this.viewOption = VIEW_OPTION.EVERY_WEEK
                } else {
                    this.viewOption = VIEW_OPTION.ONCE
                }
            }
        },
        created() {
            if (this.isRepeat) {
                this.viewOption = VIEW_OPTION.EVERY_WEEK
            } else {
                this.viewOption = VIEW_OPTION.ONCE
            }

            const today = new Date()

            const year = today.getFullYear()
            let month = today.getMonth() + 1;
            let day = today.getDate();

            if (month < 10) {
                month = '0' + month
            }

            if (day < 10) {
                day = '0' + day;
            }

            this.join_date = year + '-' + month + '-' + day
        },

    }
</script>

<style scoped></style>